import HomeHeader from "../../components/DashBoardComponents/Home/HomeHeader/index";
import HomeUnverified from "../../components/DashBoardComponents/Home/HomeBalances/homeUnverifiedBalance";
import HomeProductSection from "../../components/DashBoardComponents/Home/HomeProduct/index";
import Chart from "../../components/DashBoardComponents/Home/HomeChart/homeNotVerified";
import CompleteAccountSetUp from "../../components/DashBoardComponents/Home/CompleteAccount/index";
import PaymentAnalyticsComponent from "../../components/DashBoardComponents/PaymentLink/PaymentAnalytics/index";
import { PaymentAnalyticsContainer } from "../Dashboard/Dashboard.styles";

import {
  BalanceContainer,
  OurProductContainer,
  ChatContainer,
  CompleteContainer,
} from "../Home/home.styles";
import HomeProduct from "../../components/DashBoardComponents/Home/HomeProductModal";
import Otp from "../Otp/OtpPage";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/rootReducer";
import {
  setFirstModalOpen,
  setSecondModalOpen,
} from "../../store/modal/modalSlice";
import WelcomeModal from "../../components/WelcomeToFipayModal/WelcomeModal";

const Index = () => {
  const dispatch = useDispatch();

  const handleSkipTutorial = () => {
    dispatch(setFirstModalOpen(false));
    dispatch(setSecondModalOpen(true));
    dispatch(setFirstModalOpen(false));
    dispatch(setSecondModalOpen(true));
  };

  const { firstModalOpen, secondModalOpen } = useSelector(
    (state: RootState) => state.modal
  );
  const handleSkipSecondModal = () => {
    dispatch(setSecondModalOpen(false));
  };
  return (
    <>
      <HomeHeader />
      <CompleteContainer>
        <CompleteAccountSetUp />
      </CompleteContainer>
      <BalanceContainer>
        <HomeUnverified />
      </BalanceContainer>
      <OurProductContainer>
        <HomeProductSection />
      </OurProductContainer>
      <ChatContainer>
        <Chart />
      </ChatContainer>
      <PaymentAnalyticsContainer>
        <PaymentAnalyticsComponent />
      </PaymentAnalyticsContainer>
      {firstModalOpen && (
        <WelcomeModal handleSkipTutorial={handleSkipTutorial} />
      )}
      {secondModalOpen && <HomeProduct handleSkip={handleSkipSecondModal} />}
      {firstModalOpen && (
        <WelcomeModal handleSkipTutorial={handleSkipTutorial} />
      )}
      {secondModalOpen && <HomeProduct handleSkip={handleSkipSecondModal} />}
    </>
  );
};

export default Index;
